import React, { useCallback, useState } from 'react';
import mainStyle from '../../ContexteCreationStyle';
import style from './style';
import EAHint from 'components/common/EAHint';
import AttributsList from './AttributsList';
import EADialog from '../../../../../../components/common/EADialog';
import {
  useFieldArray,
  useFormContext,
  useWatch,
} from 'react-hook-form';
import AttributeForm from '../../../../attributes/AttributeForm';
import { ContextBondTypes } from '../../../../../../services/common/Constants';

export const AttributsRight = ({
  attributContextType,
  title,
  hint,
  listTitle,
  listTitleExample,
  dialogTitle,
}) => {
  const { classes: mainStyleClasses } = mainStyle();
  const { classes } = style();
  const [openCreateContextAttribute, setOpenCreateContextAttribute] = useState(
    false
  );
  const [editedAttribute, setEditedAttribute] = useState();
  const formId = attributContextType;

  const bondType = (() => {
    switch (attributContextType) {
      case 'contextAttributes':
        return ContextBondTypes.CONTEXT;
      case 'tiersAttributes':
        return ContextBondTypes.CONTEXT_THIRD_PARTY;
      case 'demandeAttributes':
        return ContextBondTypes.CONTEXT_THIRD_PARTY_DEMAND;
      default:
        return null
    }
  })();

  const { control,     getValues, } = useFormContext();

  const {
    append: appendContextAttribute,
    remove: removeContextAttribute,
    update: updateAttribute,
  } = useFieldArray({
    control,
    name: attributContextType,
  });

  const currentContextAttributes = useWatch({
    control,
    name: attributContextType,
  });

  const closeContextAttribute = useCallback(() => {
    setOpenCreateContextAttribute(false);
  }, []);

  const addAttribute = (attribute) => {
    appendContextAttribute(attribute);
    setOpenCreateContextAttribute(false);
  }

  const editAttribute = useCallback((attribute) => {
    const attributes = getValues(attributContextType);
    const index = attributes.findIndex((att) => att.label === editedAttribute.label);

    if (index !== -1) {
      updateAttribute(index, attribute);
    }
    setOpenCreateContextAttribute(false);
  }, [editedAttribute, getValues, updateAttribute, attributContextType])

  const onEditAttribute = (attribute) => {
    setEditedAttribute(attribute);
    setOpenCreateContextAttribute(true)
  }

  return (
    <div className={classes.content}>
      <h2 className={mainStyleClasses.rightMainTitle}>{title}</h2>
      <EAHint content={hint} />
      <AttributsList
        title={listTitle}
        titleExample={listTitleExample}
        onCreateAttribute={() => {
          setEditedAttribute(null)
          setOpenCreateContextAttribute(true);
        }}
        attributs={currentContextAttributes}
        removeAttribute={removeContextAttribute}
        onEdit={onEditAttribute}
      />
      <EADialog
        formId={formId}
        isOpen={openCreateContextAttribute}
        title={dialogTitle}
        onCancel={closeContextAttribute}
        onClose={closeContextAttribute}
        maxWidth={'popupmd'}
        fullWidth
        hasActions={true}
        displayBtn={true}
        variant={'rightControl'}
      >
        {openCreateContextAttribute && (
          <AttributeForm
            setIsValidateDisabled={() => {}}
            submitHandler={editedAttribute?editAttribute:addAttribute}
            bondType={bondType}
            formId={formId}
            formType={editedAttribute?'edit':'create'}
            attribute={editedAttribute?editedAttribute:null}
          />
        )}
      </EADialog>
    </div>
  );
};
